import React from "react";

function Bio() {
  return (
    <React.Fragment>
      <div class="container">
        <div class="w-75 mx-auto mt-5 text-center lh-lg">
          د. محمد هادي الحويلة عمل عضو هيئة تدريس في أكاديمية سعد العبد الله
          للعلوم الأمنية والجامعة العربية المفتوحة ويحظى بعضوية المعهد الدولي
          للدراسات الإستراتيجية والمعهد الملكي للدراسات الدولية في لندن وعضو في
          جمعية الصحافيين الكويتية وجمعية الصحافيين الدولية وحاز على عضوية مجلس
          الأمة في الدائرة الخامسة بنجاح خلال سنوات
          <div className="text-center h5 my-3">
            2022-2020-2016-2013-2009-2008.
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Bio;
